import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import validate from '@/validate/validate';
export default {
  name: 'user-form',
  props: {
    list: {
      default: function _default() {
        return [];
      }
    },
    data: {},
    handler: {}
  },
  computed: {
    isEdit: function isEdit() {
      return !!this.data;
    }
  },
  data: function data() {
    return {
      form: {
        nickName: undefined,
        userName: undefined,
        email: undefined,
        phone: undefined
      },
      rules: {
        tenantUserName: [{
          required: true,
          message: '请输入租户内账号',
          trigger: 'change'
        }],
        tenantNickName: [{
          required: true,
          message: '请输入租户内人员姓名',
          trigger: 'change'
        }],
        userName: [{
          required: true,
          message: '请输入用户手机号码',
          trigger: 'change'
        }, {
          message: '请输入正确的手机号码',
          trigger: 'change',
          validator: validate.isPhone
        }],
        email: [{
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'change'
        }]
      },
      loading: false
    };
  },
  methods: {
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, _yield$_this$$awaitTo3, _yield$_this$$awaitTo4, _err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$checkForm();
            case 1:
              _this.loading = true;
              if (!_this.isEdit) {
                _context.n = 4;
                break;
              }
              _context.n = 2;
              return _this.$awaitTo(_this.handler({
                username: _this.form.tenantUserName,
                nickname: _this.form.tenantNickName,
                email: _this.form.email,
                phone: _this.form.userName
              }));
            case 2:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              _this.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _context.n = 6;
              break;
            case 4:
              _context.n = 5;
              return _this.$awaitTo(_this.handler([_this.form], false));
            case 5:
              _yield$_this$$awaitTo3 = _context.v;
              _yield$_this$$awaitTo4 = _slicedToArray(_yield$_this$$awaitTo3, 1);
              _err = _yield$_this$$awaitTo4[0];
              _this.loading = false;
              if (!_err) {
                _context.n = 6;
                break;
              }
              return _context.a(2);
            case 6:
              _this.$message.success('操作成功');
              _this.$emit('submit');
              _this.loading = false;
            case 7:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    cancel: function cancel() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.$emit('cancel');
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    if (this.data) {
      this.form = _objectSpread(_objectSpread({}, this.form), this.data);
    }
  }
};